import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    userDetails: null,
    userRole: null,
    controlBy: "",
    controlAction: "",
    viewJob: "",
    controlUser: "",
    controlJobRole: "",
    isAllowRefetch: false,
    selectedUserId: ""
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setSelectedUserId(state, action) {
            state.selectedUserId = action.payload;
        },
        setAllowRefetch(state, action) {
            state.isAllowRefetch = action.payload;
        },
        setUserDetails(state, action) {
            state.userDetails = action.payload;
        },
        setUserRole(state, action) {
            state.userRole = action.payload;
        },
        setPortalControlBy(state, action) {
            state.controlBy = action.payload;
        },
        setControlAction(state, action) {
            state.controlAction = action.payload;
        },
        setControlUser(state, action) {
            state.controlUser = action.payload;
        },
        setControlJobRole(state, action) {
            state.controlJobRole = action.payload;
        },
        setViewJob(state, action) {
            state.viewJob = action.payload;
        },
        clearJob(state, action) {
            state.viewJob = "";
        },
        clearUser: () => initialState,
    },
});

// Export the actions generated by createSlice
export const { setUserDetails, setUserRole, clearUser, setPortalControlBy, setControlUser, setControlJobRole, setControlAction, setViewJob, clearJob, setAllowRefetch, setSelectedUserId } = userSlice.actions;

// Export the reducer to be used in the store
export default userSlice.reducer;
